import React, { useRef, useState, useEffect } from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  tooltip: {
    maxWidth: "184px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    color: "black",
    border: "#70707075 1px solid",
    boxShadow: "0px 3px 6px #00000029",
    opacity: 1,
    fontSize: 12,
    // width: "184px",             
    minHeight: "44px",           
    borderRadius: "2px",
    // marginTop: "0px",
  },
  arrow: {
    "&:before": {
      border: "1px solid #70707075",
    },
    color: "white",
    fontSize: "15pt",
  },
});


function SubformTooltip({ text, classes }) {
  const stylesTooltip = useStyles();  
  const textRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    if (textRef.current) {
      setIsTruncated(textRef.current.scrollWidth > textRef.current.clientWidth);
    }
  }, [text]);

  return (
    <Tooltip
      title={isTruncated ? text : ""}
      placement="top-end"
      classes={{ tooltip: stylesTooltip.tooltip, arrow: stylesTooltip.arrow }}
      arrow
      disableHoverListener={!isTruncated}
      enterTouchDelay={0}
    >
      <span
        ref={textRef}
        className={classes.fonts}
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "inline-block",
          maxWidth: "100%",
          lineHeight:'normal' 
        }}
      >
        {text}
      </span>
    </Tooltip>
  );
}

export default SubformTooltip;
